import PropTypes from "prop-types";
import { MiModal } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { mdiLockOutline } from "@mdi/js";
import { useTheme } from "@mui/material";

export function AutoLockModal({
  closeModal = () => null,
  confirmAction = () => null,
  isReschedule = true,
  open = false,
}) {
  const theme = useTheme();

  return (
    <MiModal
      open={open}
      closeModal={closeModal}
      actions={[
        {
          name: "Cancel",
          onClick: closeModal,
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
        },
        {
          name: `${isReschedule ? "Reschedule" : "Schedule"} & Lock`,
          onClick: confirmAction,
          variant: BUTTON_VARIANTS.CONTAINED,
          color: BUTTON_COLORS.PRIMARY,
        },
      ]}
      width={448}
      title={`${isReschedule ? "Reschedule" : "Schedule"} & Lock Attempt`}
      titleIcon={mdiLockOutline}
      leftIconColor={theme.palette.primary.main}
      description={`By ${
        isReschedule ? "rescheduling" : "scheduling"
      } this card to a new day a system lock will be placed on it. Do you wish to continue?`}
    />
  );
}

AutoLockModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  confirmAction: PropTypes.func,
  isReschedule: PropTypes.bool,
};
